import { EMPTY_STRING } from '../../../../../constants/common'

import { FIELDS } from './useDragDropRecipients.constants'

export function getDraggableItemId(value) {
  return value.split('-')[1]
}

export function isValidDestination(event) {
  const overId = event?.over?.id

  if (!overId) {
    return false
  }

  const destinationId = String(overId)

  if (!FIELDS.includes(destinationId)) {
    return false
  }

  const sourceId = event?.active?.data?.current?.sourceFieldId

  if (!sourceId || String(sourceId) === destinationId) {
    return false
  }

  return true
}

export function getSourceFieldIdFromActive(active) {
  return String(active?.data?.current?.sourceFieldId || EMPTY_STRING)
}
